import { Alert } from '@populix/pop-ui'
import React, { useState } from 'react'
import { MdHelpOutline } from 'react-icons/md'

export type TAutoWithdrawalInfo = {
  platformName: string
}

export default function AutoWithdrawalInfo({ platformName }: Readonly<TAutoWithdrawalInfo>) {
  const [openAlert, setOpenAlert] = useState<boolean>(false)

  return (
    <>
      <Alert
        title={`Auto withdrawal to ${platformName} is enabled`}
        description={
          <ul className='ml-4 list-outside list-disc text-sm font-normal text-pop-grey-700'>
            <li>Future survey reward will be transferred directly to {platformName} account.</li>
            <li>Existing rewards can be withdrawn manually.</li>
          </ul>
        }
        isOpen={openAlert}
        backButtonTitle='OK'
        onClose={() => setOpenAlert(false)}
      />
      <div className='flex flex-row items-center justify-center gap-1 rounded-full border bg-pop-blue-50 p-1'>
        <span className='text-xs font-semibold text-pop-blue-700'>
          Auto withdrawal to {platformName} is enabled
        </span>
        <MdHelpOutline
          width={12}
          height={12}
          className='h-3 w-3 cursor-pointer text-pop-blue-700'
          onClick={() => setOpenAlert(true)}
        />
      </div>
    </>
  )
}
